export default __webpack_public_path__ + "static/media/tworzenie-eventu-1.fcec5813.png";